import { render, staticRenderFns } from "./ShippingMethodsWarehousePickup.vue?vue&type=template&id=38d351a8"
import script from "./ShippingMethodsWarehousePickup.vue?vue&type=script&lang=js"
export * from "./ShippingMethodsWarehousePickup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports